import posthog from 'posthog-js';

export const initPostHog = () => {
  const token = process.env.REACT_APP_POSTHOG_PROJECT_TOKEN;

  if (!token || posthog.__loaded) return;

  try {
    posthog.init(token, {
      api_host:
        process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
      defaults: '2026-05-30',
      person_profiles: 'identified_only',
      autocapture: true,
      session_recording: { maskAllInputs: false },
      debug: process.env.NODE_ENV !== 'production',
    });
  } catch (error) {
    console.error('Failed to initialize PostHog', error);
  }
};

export const identifyUser = (user) => {
  if (!posthog.__loaded || !user?.id) return;

  try {
    posthog.identify(user.id, {
      email: user.email,
      name: user.full_name,
      companyName: user.company_name,
    });
  } catch (error) {
    console.error('Failed to identify PostHog user', error);
  }
};

export const resetPostHog = () => {
  if (!posthog.__loaded) return;

  try {
    posthog.reset();
  } catch (error) {
    console.error('Failed to reset PostHog', error);
  }
};
